module.exports = __webpack_public_path__ + "static/img/9areaB_02.ea4a311.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_02.png
// module id = 1234
// module chunks = 1